import { ActiveChatUserBtnActionType } from '../../types/activeChatUserBtnType'

export const setActiveChatUserBtn = (value: number) => {
    return {type: ActiveChatUserBtnActionType.SET_ACTIVE_USER_CHAT_BTN, payload: value}
}